import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const SearchInput = ({ value, onChange, placeholder = 'Search by Name, Phone, or Email', sx = {}, ...props }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:800px)');

  return (
    <TextField
      label="Search"
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={onChange}
      sx={{
        minWidth: isSmallScreen ? '100%' : 250,
        borderRadius: 2,
        flexGrow:1,
        background: 'background.text',
        color: 'background.text',
        boxShadow: 1,
        '& .MuiInputBase-root': {
          borderRadius: 2,
          height: 40,
          color: 'background.text',
        },
        ...sx,
      }}
      InputLabelProps={{sx:{color:'#56B6C2'}  }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
        sx: {
          borderRadius: 2,
          height: 40,
          fontSize: 15,
          padding: '0 10px',
          color: 'background.text',
        },
      }}
      inputProps={{
        style: {
          height: 40,
          padding: '0 0 0 0',
          fontSize: 15,
          color: 'background.text',
        },
      }}
      {...props}
    />
  );
};

export default SearchInput;